import { render, staticRenderFns } from "./VPesquisa.vue?vue&type=template&id=a4c98af6&scoped=true&"
import script from "./VPesquisa.vue?vue&type=script&lang=js&"
export * from "./VPesquisa.vue?vue&type=script&lang=js&"
import style0 from "./VPesquisa.vue?vue&type=style&index=0&id=a4c98af6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c98af6",
  null
  
)

export default component.exports